import { render, staticRenderFns } from "./FunnelAddOrEdit.vue?vue&type=template&id=0879f526"
import script from "./FunnelAddOrEdit.vue?vue&type=script&lang=js"
export * from "./FunnelAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./FunnelAddOrEdit.vue?vue&type=style&index=0&id=0879f526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports